import type { GenerateTourIsolineApiResponse } from '../../../src/store/facade/facadeApiV2';

export const generateIsolineMock = () => {
    return {
        items: [
            {
                points: [
                    {
                        latitude: 48.210068,
                        longitude: 11.462367,
                    },
                    {
                        latitude: 49.209767,
                        longitude: 11.466079,
                    },
                    {
                        latitude: 49.213201,
                        longitude: 12.471143,
                    },
                    {
                        latitude: 48.210454,
                        longitude: 12.467538,
                    },
                ],
            },
            {
                points: [
                    {
                        latitude: 58.210068,
                        longitude: 21.462367,
                    },
                    {
                        latitude: 59.209767,
                        longitude: 21.466079,
                    },
                    {
                        latitude: 59.213201,
                        longitude: 22.471143,
                    },
                    {
                        latitude: 58.210454,
                        longitude: 22.467538,
                    },
                ],
            },
        ],
    };
};

export type IsolinePoints = string[];
export const generateTourIsolineMock = (coords?: IsolinePoints): GenerateTourIsolineApiResponse => {
    if (coords) {
        return {
            coordinates: coords.map(coord => {
                const [latitude, longitude] = coord.split(', ').map(it => Number(it));
                return {
                    latitude,
                    longitude,
                };
            }),
        };
    }
    return {
        coordinates: [
            {
                latitude: 48.210068,
                longitude: 11.462367,
            },
            {
                latitude: 49.209767,
                longitude: 11.466079,
            },
            {
                latitude: 49.213201,
                longitude: 12.471143,
            },
            {
                latitude: 48.210454,
                longitude: 12.467538,
            },
        ],
    };
};

export const isolineMunichBerlin: IsolinePoints = [
    '52.6890, 10.4577',
    '52.6890, 14.8305',
    '48.0185, 15.0258',
    '48.0480, 9.9347',
];
